<script setup lang="ts">
const { menu } = defineProps<{
  menu: IMenu
}>()

const modelValue = ref(!!menu.initialValue)
</script>

<template>
  <MenuDesktop
      class="hidden-xs"
      :menu="menu"
  >
    <MenuItems :items="menu.items" />
  </MenuDesktop>
  <MenuMobile
    class="hidden-sm-and-up"
    :model-value="modelValue"
    :menu="menu"
  >
    <MenuItems
        :items="menu.items"
        @close="modelValue = false"
    />
  </MenuMobile>
</template>

<style scoped lang="scss">
.menu {

}
</style>